import { Anchor } from '@zooplus/ui-components';

import { useTranslation } from '@hooks/use-translations';

import styles from './cart-logistics-fees.module.scss';

type MessageProps = {
  formattedTotalWeight: string;
  feeDetails: {
    feeFactor?: number;
    formattedFeeValue: string;
    baseWeight: number;
  };
};
const CartLogisticsFeesMessage = ({ formattedTotalWeight, feeDetails }: MessageProps) => {
  const { t } = useTranslation();

  const infoBoxMessage = t('cart.summary.logisticFeesModal.infoBoxMessage', {
    0: formattedTotalWeight,
    1: (feeDetails?.feeFactor || 0) + 1,
    2: feeDetails?.formattedFeeValue,
  });
  const parts = infoBoxMessage.split(/<a[^>]*>(.*?)<\/a>/);
  return (
    <>
      {parts.map((part, index) =>
        index === 1 ? (
          <Anchor
            key={index}
            className={styles.shippingcostLink}
            href="/content/shippingcosts#2"
            target="_blank">
            {part}
          </Anchor>
        ) : (
          part
        ),
      )}
    </>
  );
};

export default CartLogisticsFeesMessage;
